// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3F1iq","row":"styles_row__2RgWk"};